var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchVenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 133.333,
    width: 133.333,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 100h100V0H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 133.333)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M0 0h-3.963a7.995 7.995 0 0 1-7.995-7.995v-49.062a7.995 7.995 0 0 1 7.995-7.995h70.009a7.996 7.996 0 0 1 7.996 7.995v49.062A7.996 7.996 0 0 1 66.046 0l-7.504.115c-5.051 0-8.09 2.049-11.223 6.01a12.53 12.53 0 0 0-1.393 2.144c-2.205 4.41-7.718 5.513-15.436 5.513s-13.231-1.103-15.436-5.513c-.441-.882-1.074-1.742-1.805-2.554C9.892 1.99 5.015 0 0 0Z",
    transform: "translate(18.959 76.385)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M0 0c0-7.916-6.417-14.333-14.333-14.333S-28.667-7.916-28.667 0s6.418 14.333 14.334 14.333C-6.417 14.333 0 7.916 0 0Z",
    transform: "translate(63.23 43.308)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a6.615 6.615 0 1 0-13.23 0A6.615 6.615 0 0 0 0 0",
    transform: "translate(84.73 61.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchVenue);
export default __webpack_public_path__ + "static/media/search-venue.f8de61c6a6ffd598c05c695c2982b3c8.svg";
export { ForwardRef as ReactComponent };